import "./types";

export const {
    builtin: {
        bool: { true$: pyTrue, false$: pyFalse },
        none: { none$: pyNone },
        NotImplemented: { NotImplemented$: pyNotImplemented },

        bool: pyBool,
        bytes: pyBytes,
        dict: pyDict,
        float_: pyFloat,
        frozenset: pyFrozenSet,
        func: pyFunc,
        int_: pyInt,
        list: pyList,
        none: pyNoneType,
        mappingproxy: pyMappingProxy,
        module: pyModule,
        object: pyObject,
        set: pySet,
        slice: pySlice,
        sk_method: pyBuiltinFunctionOrMethod,
        str: pyStr,
        tuple: pyTuple,
        type: pyType,

        classmethod: pyClassMethod,
        staticmethod: pyStaticMethod,
        property: pyProperty,

        BaseException: pyBaseException,
        SystemExit: pySystemExit,
        KeyboardInterrupt: pyKeyboardInterrupt,
        GeneratorExit: pyGeneratorExit,
        Exception: pyException,
        StopIteration: pyStopIteration,
        StopAsyncIteration: pyStopAsyncIteration,
        ArithmeticError: pyArithmeticError,
        FloatingPointError: pyFloatingPointError,
        OverflowError: pyOverflowError,
        ZeroDivisionError: pyZeroDivisionError,
        AssertionError: pyAssertionError,
        AttributeError: pyAttributeError,
        BufferError: pyBufferError,
        EOFError: pyEOFError,
        ImportError: pyImportError,
        ModuleNotFoundError: pyModuleNotFoundError,
        LookupError: pyLookupError,
        IndexError: pyIndexError,
        KeyError: pyKeyError,
        MemoryError: pyMemoryError,
        NameError: pyNameError,
        UnboundLocalError: pyUnboundLocalError,
        OSError: pyOSError,
        FileNotFoundError: pyFileNotFoundError,
        TimeoutError: pyTimeoutError,
        ReferenceError: pyReferenceError,
        RuntimeError: pyRuntimeError,
        NotImplementedError: pyNotImplementedError,
        RecursionError: pyRecursionError,
        SyntaxError: pySyntaxError,
        IndentationError: pyIndentationError,
        TabError: pyTabError,
        SystemError: pySystemError,
        TypeError: pyTypeError,
        ValueError: pyValueError,
        UnicodeError: pyUnicodeError,
        UnicodeDecodeError: pyUnicodeDecodeError,
        UnicodeEncodeError: pyUnicodeEncodeError,
        ExternalError: pyExternalError,

        checkString,
        checkBool,
        checkInt,
        checkAnySet,
        checkBytes,
        checkCallable,
        checkIterable,
        checkNone,

        issubclass: pyIsSubclass,
        isinstance: pyIsInstance,
        hasattr: pyHasAttr,
    },
    misceval: {
        isTrue,
        Suspension,
        Break,
        chain: chainOrSuspend,
        tryCatch: tryCatchOrSuspend,
        retryOptionalSuspensionOrThrow,
        objectRepr,
        buildClass: buildPyClass,
        iterFor: iterForOrSuspend,
        iterArray,
        richCompareBool,
        callsimArray: pyCall,
        callsimOrSuspendArray: pyCallOrSuspend,
        arrayFromIterable,
        asyncToPromise: suspensionToPromise,
        promiseToSuspension,
    },
    abstr: {
        buildNativeClass,
        copyKeywordsToNamedArgs,
        checkArgsLen,
        checkNoArg,
        checkNoKwargs,
        checkOneArg,
        keywordArrayFromPyDict,
        keywordArrayToPyDict,
        iter: pyIter,
        lookupSpecial,
        typeLookup,
        setUpModuleMethods,
    },
    ffi: { toPy, toJs, proxy },
} = Sk;

export type { Args, Kws, CompareOp, BinOp, UnaryOp } from "./namespace";